import { EsField } from '../../../../services/dtos/riskProducts/rpColumn.dto';

export const REQUIRED_COLUMNS: EsField[] = [
  'display_name',
  'display_ticker',
  'selection',
  'displayName',
  'displayTicker',
];
